import React from 'react';
import { withFormsy } from 'formsy-react';
import { TwitterPicker } from 'react-color';
import { Button, Popover, styled, type ButtonProps } from '@mui/material';

import { type FieldProps } from './components/BaseTextField';

type RootProps = Pick<FieldProps<string>, 'value' | 'isEdit'> & Omit<ButtonProps, 'value'>;

type ColorPickerFieldProps = Omit<FieldProps<string>, 'startAdornment' | 'endAdornment'>;

const Root = styled((props: RootProps) => {
	const { value, isEdit, ...other } = props;
	return <Button {...other} />;
})(({ isEdit, theme, value }) => ({
	width: '100%',
	height: '100%',
	color: isEdit ? theme.palette.getContrastText(value || '#000000') : `${value} !important`,
	backgroundColor: isEdit ? value || '#000000' : 'transparent',
	'&:hover': {
		backgroundColor: isEdit ? value || '#000000' : 'transparent'
	}
}));

const TwitterColorPicker = styled(TwitterPicker)(({ theme }) => ({
	backgroundColor: theme.palette.background.paper
}));

function ColorPickerField(props: ColorPickerFieldProps) {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	const handleClick = event => {
		if (props.isEdit) setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleChangeColor = color => {
		if (props.beforeChange) props.beforeChange(color.hex);
		props.sendChange(props.name, color.hex);
		if (props.afterChange) props.afterChange(color.hex);
		// setDialogOpen(false);
	};

	return (
		<>
			<Root
				className={props.className}
				name={props.name}
				value={props.value}
				variant={props.isEdit ? 'contained' : 'text'}
				onClick={handleClick}
				disabled={!props.isEdit}
				isEdit={props.isEdit}
			>
				{props.value || '#000000'}
			</Root>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				PaperProps={{ className: 'rounded-none' }}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
			>
				<TwitterColorPicker color={props.value || '#000000'} onChange={handleChangeColor} />
			</Popover>
		</>
	);
}

export default React.memo(withFormsy(ColorPickerField));
